export const TEST_ID = 'cardActionLinkText';
